/** Static PMTiles cadastral base — visible from this zoom with fade-in. */
export const MAPPER_CADASTRAL_DISPLAY_MIN_ZOOM = 9;
/** Parcel labels fade in from this zoom. */
export const MAPPER_CADASTRAL_LABEL_MIN_ZOOM = 11;
/** Click/hover interaction threshold (unchanged UX contract). */
export const MAPPER_BOUNDARY_ZOOM_THRESHOLD = 12;
export const FOCUS_FARM_SEARCH_EVENT = 'mapper:focus-farm-search';
/** Header → open the multi-format import drawer. */
export const MAPPER_OPEN_IMPORT_EVENT = 'mapper:open-import';
/** Header → open the Find-by-entity (deeds) drawer. */
export const MAPPER_OPEN_FIND_ENTITY_EVENT = 'mapper:open-find-entity';

export const MAPPER_CADASTRAL_PMTILES_PATH =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_CADASTRAL_PMTILES_URL)
    || '/tiles/cadastral/parcels-current.pmtiles';
